module.exports = __webpack_public_path__ + "img/2u_icon.74762116.png";